import React, { useEffect, createElement } from 'react';
import { BookOpen, Heart, ArrowRight, Check, Star, Shield, CreditCard, Zap, Clock, Gift, ChevronDown } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { TestimonialCard } from './TestimonialCard';
import { BonusCard } from './BonusCard';
import { FAQAccordion } from './FAQAccordion';
import { PurchaseSection } from './PurchaseSection';
export function SalesPage() {
  const PURCHASE_LINK = 'https://pay.hotmart.com/Q104345987V?checkoutMode=10';
  // Meta Pixel Installation - Real Implementation
  useEffect(() => {
    // Prevent duplicate pixel installation
    if ((window as any).fbq) return;
    const pixelId = '3070568583125644';
    // Initialize fbq function
    const fbq = function (...args: any[]) {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        ;
        (fbq as any).queue.push(args);
      }
    } as any;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [] as any[];
    (window as any).fbq = fbq;
    if (!(window as any)._fbq) (window as any)._fbq = fbq;
    // Load the Facebook pixel script safely
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
    // Add noscript pixel fallback
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    document.body.appendChild(img);
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#fffbf0] font-sans text-gray-800 pt-10" data-id="element-82">
      <CountdownTimer data-id="element-83" />
      <SocialProofPopup data-id="element-84" />

      {/* ============ HERO SECTION ============ */}
      <header className="relative pt-12 pb-16 md:pt-20 md:pb-24 px-4 overflow-hidden" data-id="element-85">
        <div className="max-w-6xl mx-auto" data-id="element-86">
          {/* Title + Subtitle centered */}
          <div className="text-center mb-10" data-id="element-87">
            <span className="inline-block py-1.5 px-4 rounded-full bg-red-100 text-red-700 text-sm font-bold mb-6 tracking-wide uppercase animate-pulse" data-id="element-88">
              ⚡ Más de 2,300 mujeres ya lo tienen
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 leading-tight mb-4" data-id="element-89">
              Cuando más necesitas respuestas,
            </h1>
            <h2 className="text-2xl md:text-3xl font-serif text-amber-700 italic" data-id="element-90">
              no sabes qué leer en la Biblia
            </h2>
          </div>

          {/* Product image right below title */}
          <div className="flex justify-center mb-12" data-id="element-91">
            <a onClick={scrollToPurchase} className="cursor-pointer block" data-id="element-92">
              <div className="relative mx-auto w-3/4 md:w-full max-w-sm" data-id="element-93">
                <div className="absolute inset-0 bg-amber-200 rounded-full filter blur-3xl opacity-30 animate-pulse" data-id="element-94"></div>
                <img src="https://cdn.magicpatterns.com/uploads/5XNMqLijddwv2VPTGtmFEv/1_cover_-removebg-preview.png" alt="Portada del libro Qué leer en la Biblia" className="relative z-10 w-full drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-95" />
              </div>
            </a>
          </div>

          {/* Body copy + CTA */}
          <div className="max-w-2xl mx-auto text-center" data-id="element-96">
            <div className="space-y-5 text-lg text-gray-700 mb-10 leading-relaxed" data-id="element-97">
              <p data-id="element-98">
                Tienes una Biblia en casa. Sabes que ahí hay palabras que pueden
                ayudarte.
              </p>
              <p data-id="element-99">
                Pero cuando tu vida se desordena, la abres… y no sabes por dónde
                empezar.
              </p>
              <p className="font-medium text-gray-900 border-l-4 border-amber-400 pl-4 bg-amber-50 py-3 pr-4 rounded-r-lg text-left" data-id="element-100">
                Sientes confusión. Cansancio emocional. Culpa por no saber qué
                leer.
              </p>
              <p className="text-xl font-medium" data-id="element-101">Y la cierras.</p>
            </div>

            <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white text-lg font-bold py-5 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center justify-center gap-2 mb-4" data-id="element-102">
              <span data-id="element-103">👉 Quiero encontrar paz ahora</span>
            </button>
            <p className="text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-104">
              <Shield className="w-4 h-4 text-green-600" data-id="element-105" />
              Garantía de 7 días · Si no te sirve, te devolvemos tu dinero
            </p>
          </div>
        </div>
      </header>

      {/* ============ PRODUCT INTRO ============ */}
      <section className="py-16 bg-white relative" data-id="element-106">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-107">
          <BookOpen className="w-12 h-12 text-amber-500 mx-auto mb-6" data-id="element-108" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-109">
            📖 Qué leer en la Biblia cuando no sabes qué hacer
          </h2>
          <h3 className="text-xl text-amber-700 font-serif italic mb-8" data-id="element-110">
            Guía práctica para encontrar calma, claridad y respuestas en los
            momentos más difíciles de tu vida
          </h3>
          <div className="max-w-2xl mx-auto text-lg text-gray-600 leading-relaxed space-y-4" data-id="element-111">
            <p data-id="element-112">
              Este no es un estudio bíblico. No es teoría. No es religión
              complicada.
            </p>
            <p className="font-medium text-gray-800 text-xl" data-id="element-113">
              Es la guía que te toma de la mano y te dice{' '}
              <span className="text-amber-700" data-id="element-114">exactamente</span> qué leer según
              lo que estás viviendo hoy.
            </p>
          </div>
        </div>
      </section>

      {/* ============ SOCIAL PROOF - TESTIMONIALS (MOVED UP) ============ */}
      <section className="py-20 bg-[#fffbf0]" data-id="element-115">
        <div className="max-w-6xl mx-auto px-4" data-id="element-116">
          <div className="text-center mb-4" data-id="element-117">
            <span className="inline-block py-1 px-3 rounded-full bg-green-100 text-green-700 text-sm font-bold mb-4" data-id="element-118">
              ⭐ Historias reales de mujeres como tú
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gray-900 mb-12" data-id="element-119">
            Ellas ya encontraron la paz que buscaban
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-120">
            <TestimonialCard name="María José R." location="Medellín, Colombia · 34 años" quote="Estaba pasando por lo peor de mi matrimonio. Abrí la guía en la sección de 'miedo' y por primera vez en semanas, pude respirar. Sentí que Dios me hablaba directo al corazón." rating={5} data-id="element-121" />
            <TestimonialCard name="Valentina G." location="Buenos Aires, Argentina · 41 años" quote="Siempre quise leer la Biblia pero me sentía perdida y culpable. Esta guía me tomó de la mano. Ahora la abro todos los días y sé exactamente qué leer. Me cambió la vida." rating={5} data-id="element-122" />
            <TestimonialCard name="Carolina M." location="Lima, Perú · 29 años" quote="Tenía ansiedad terrible y no podía dormir. Empecé con la sección de miedo y fue como si alguien me abrazara. Lo recomiendo con todo mi corazón." rating={5} data-id="element-123" />
          </div>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-124">
            <TestimonialCard name="Lucía P." location="Ciudad de México · 38 años" quote="No soy muy religiosa, pero necesitaba algo. Esta guía no me juzgó, me acompañó. Los bonos de oración me cambiaron la vida. Ahora sé qué decirle a Dios." rating={5} data-id="element-125" />
            <TestimonialCard name="Gabriela S." location="Santiago, Chile · 45 años" quote="Lo compré para mí y terminé regalándoselo a mi hermana y a mi mamá. Las tres lloramos juntas leyéndolo. Es exactamente lo que necesitábamos." rating={5} data-id="element-126" />
          </div>

          <div className="text-center mt-10" data-id="element-127">
            <button onClick={scrollToPurchase} className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg inline-flex items-center justify-center" data-id="element-128">
              Yo también quiero sentir esa paz →
            </button>
          </div>
        </div>
      </section>

      {/* ============ PAIN POINTS ============ */}
      <section className="py-20 bg-amber-50" data-id="element-129">
        <div className="max-w-5xl mx-auto px-4" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gray-900 mb-4" data-id="element-131">
            Si esto te pasa, este ebook fue creado para ti
          </h2>
          <p className="text-center text-gray-600 mb-12 text-lg" data-id="element-132">
            No estás sola. Miles de mujeres sienten exactamente lo mismo.
          </p>

          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-133">
            <div className="space-y-4" data-id="element-134">
              {['Oras, pero no sientes paz… y eso te frustra', 'Sientes que Dios está… pero lejos, como si no te escuchara', 'No sabes qué decisión tomar y el miedo te paraliza', 'Estás emocionalmente agotada y no tienes fuerzas', 'Tienes miedo, culpa o confusión y no sabes a quién acudir', 'Buscas respuestas reales, sin que nadie te juzgue'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm border border-amber-100" data-id="element-135">
                  <div className="bg-red-100 p-1.5 rounded-full mt-0.5" data-id="element-136">
                    <Heart className="w-4 h-4 text-red-500 fill-current" data-id="element-137" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-138">{item}</span>
                </div>)}
            </div>

            <div className="bg-gradient-to-br from-amber-100 to-amber-200 rounded-2xl p-8 md:p-12 text-center shadow-inner" data-id="element-139">
              <p className="text-5xl mb-6" data-id="element-140">🕊️</p>
              <h3 className="text-2xl font-serif font-bold text-amber-900 mb-4" data-id="element-141">
                No necesitas saber más.
              </h3>
              <h3 className="text-2xl font-serif font-bold text-amber-900 mb-6" data-id="element-142">
                Necesitas sentirte acompañada{' '}
                <span className="underline decoration-amber-500 decoration-4 underline-offset-4" data-id="element-143">
                  ahora mismo
                </span>
                .
              </h3>
              <p className="text-gray-700 mb-8" data-id="element-144">
                Esta guía es como tener a una amiga que te dice exactamente qué
                leer en el momento que más lo necesitas.
              </p>
              <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center justify-center" data-id="element-145">
                Sí, necesito esto hoy →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ============ WHAT'S INSIDE ============ */}
      <section className="py-20 bg-white" data-id="element-146">
        <div className="max-w-6xl mx-auto px-4" data-id="element-147">
          <div className="text-center mb-16" data-id="element-148">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-149">
              Este ebook no te enseña la Biblia
            </h2>
            <p className="text-xl text-amber-700 font-serif italic" data-id="element-150">
              te ayuda a usarla cuando más la necesitas
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-151">
            <div className="order-2 md:order-1" data-id="element-152">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-153">
                <BookOpen className="w-6 h-6 text-amber-500" data-id="element-154" />
                Dentro de esta guía vas a encontrar:
              </h3>
              <ul className="space-y-4 mb-10" data-id="element-155">
                {['Qué leer cuando sientes miedo y no puedes dormir', 'Qué leer cuando estás agotada y no das más', 'Qué leer cuando no sabes qué decisión tomar', 'Qué leer cuando sientes culpa o vergüenza', 'Qué leer cuando te sientes sola y perdida'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-156">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-157" />
                    <span className="text-gray-700 text-lg" data-id="element-158">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-amber-50 p-6 rounded-xl border border-amber-100" data-id="element-159">
                <h4 className="font-bold text-gray-900 mb-4" data-id="element-160">
                  Cada situación incluye:
                </h4>
                <ul className="space-y-3" data-id="element-161">
                  <li className="flex items-start gap-2" data-id="element-162">
                    <div className="w-2 h-2 bg-amber-400 rounded-full mt-2" data-id="element-163"></div>
                    <span className="text-gray-600" data-id="element-164">
                      <strong data-id="element-165">El pasaje exacto</strong> que necesitas leer (sin
                      buscar)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-166">
                    <div className="w-2 h-2 bg-amber-400 rounded-full mt-2" data-id="element-167"></div>
                    <span className="text-gray-600" data-id="element-168">
                      <strong data-id="element-169">Una explicación simple</strong>, sin palabras
                      difíciles ni teología
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-170">
                    <div className="w-2 h-2 bg-amber-400 rounded-full mt-2" data-id="element-171"></div>
                    <span className="text-gray-600" data-id="element-172">
                      <strong data-id="element-173">Cómo aplicarlo</strong> a lo que estás viviendo
                      hoy
                    </span>
                  </li>
                </ul>
                <p className="mt-4 font-serif italic text-amber-700 font-medium text-center text-lg" data-id="element-174">
                  Sin sermones. Sin presión. Sin culpa.
                </p>
              </div>
            </div>

            <div className="order-1 md:order-2 flex justify-center" data-id="element-175">
              <a onClick={scrollToPurchase} className="cursor-pointer" data-id="element-176">
                <img src="https://cdn.magicpatterns.com/uploads/5XNMqLijddwv2VPTGtmFEv/1_cover_-removebg-preview.png" alt="Interior del libro" className="w-3/4 md:w-full max-w-md drop-shadow-xl transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-177" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ============ TRANSFORMATION (HOW IT FEELS) ============ */}
      <section className="py-20 bg-[#fffbf0]" data-id="element-178">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-179">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-180">
            Imagina abrir tu Biblia y saber exactamente qué leer
          </h2>
          <p className="text-lg text-gray-600 mb-12" data-id="element-181">
            Así se siente usar esta guía desde el primer día:
          </p>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-12" data-id="element-182">
            {[{
            icon: '✨',
            text: 'Dejas de sentirte perdida al instante'
          }, {
            icon: '🧭',
            text: 'Sabes exactamente por dónde empezar'
          }, {
            icon: '🙏',
            text: 'Vuelves a conectar con Dios sin esfuerzo'
          }, {
            icon: '🕊️',
            text: 'Encuentras calma en medio del caos'
          }, {
            icon: '💡',
            text: 'Tienes respuestas cuando más las necesitas'
          }].map((item, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-amber-100" data-id="element-183">
                <p className="text-3xl mb-3" data-id="element-184">{item.icon}</p>
                <p className="text-gray-800 font-medium" data-id="element-185">{item.text}</p>
              </div>)}
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border-l-8 border-amber-500 inline-block max-w-2xl" data-id="element-186">
            <p className="text-xl md:text-2xl font-serif text-gray-700 italic" data-id="element-187">
              Este ebook es como tener a alguien que te diga:
              <br data-id="element-188" />
              <span className="font-bold text-amber-700 not-italic mt-2 block text-2xl md:text-3xl" data-id="element-189">
                "Lee esto. Ahora. Es para ti."
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* ============ TARGET AUDIENCE ============ */}
      <section className="py-20 bg-white" data-id="element-190">
        <div className="max-w-4xl mx-auto px-4" data-id="element-191">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gray-900 mb-12" data-id="element-192">
            ¿Este ebook es para ti?
          </h2>

          <div className="bg-gradient-to-br from-amber-50 to-white rounded-2xl shadow-md p-8 md:p-12 border border-amber-100" data-id="element-193">
            <p className="text-lg text-gray-700 mb-6 font-medium" data-id="element-194">
              Este ebook es para ti si:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-195">
              {['Crees en Dios, aunque hoy te sientas lejos de Él', 'Quieres paz real, no sermones ni juicios', 'Buscas respuestas claras que puedas aplicar hoy', 'No sabes por dónde empezar a leer la Biblia', 'Necesitas sentirte acompañada en este momento difícil'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-196">
                  <div className="bg-green-100 p-1 rounded-full" data-id="element-197">
                    <Check className="w-4 h-4 text-green-600" data-id="element-198" />
                  </div>
                  <span className="text-gray-800 font-medium" data-id="element-199">{item}</span>
                </li>)}
            </ul>
            <div className="bg-amber-100 rounded-xl p-6 text-center" data-id="element-200">
              <p className="text-gray-800 font-serif text-lg italic" data-id="element-201">
                No importa cuánto sepas. No importa hace cuánto no la abres.
                <br data-id="element-202" />
                <span className="font-bold not-italic text-amber-800" data-id="element-203">
                  Este ebook está pensado para que empieces HOY.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ FEATURES GRID ============ */}
      <section className="py-16 bg-amber-50" data-id="element-204">
        <div className="max-w-6xl mx-auto px-4" data-id="element-205">
          <h3 className="text-2xl font-serif font-bold text-center text-gray-900 mb-10" data-id="element-206">
            📲 Lo que recibes con tu compra:
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-207">
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-208">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-209">
                <Zap className="w-6 h-6" data-id="element-210" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-211">Acceso inmediato</h3>
              <p className="text-sm text-gray-500" data-id="element-212">
                Descarga instantánea en 2 minutos
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-213">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-214">
                <BookOpen className="w-6 h-6" data-id="element-215" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-216">Lectura simple</h3>
              <p className="text-sm text-gray-500" data-id="element-217">
                Sin palabras difíciles ni teología
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-218">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-219">
                <Heart className="w-6 h-6" data-id="element-220" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-221">Vuelve siempre</h3>
              <p className="text-sm text-gray-500" data-id="element-222">
                Material para cada momento difícil
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-223">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-224">
                <Shield className="w-6 h-6" data-id="element-225" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-226">
                Tuyo para siempre
              </h3>
              <p className="text-sm text-gray-500" data-id="element-227">
                Un solo pago, acceso de por vida
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ BONUSES (RIGHT BEFORE PURCHASE) ============ */}
      <section className="py-20 bg-white" data-id="element-228">
        <div className="max-w-6xl mx-auto px-4" data-id="element-229">
          <div className="text-center mb-16" data-id="element-230">
            <span className="bg-red-100 text-red-700 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-4 inline-block" data-id="element-231">
              🔥 Solo por hoy — Bonos gratis incluidos
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-232">
              🎁 Además, recibes estos 4 bonos valorados en $45.96
            </h2>
            <p className="text-xl text-green-600 font-bold" data-id="element-233">
              COMPLETAMENTE GRATIS con tu compra de hoy
            </p>
          </div>

          <div className="grid gap-8 mb-12" data-id="element-234">
            <BonusCard image="https://cdn.magicpatterns.com/uploads/1rhgvZ5C1wMdjofCJzh9AP/Bono_1.png" title="BONO 1: Qué decirle a Dios cuando no sabes qué decir" description="Guía práctica de oración real, sin fórmulas ni culpa. Para esos momentos en que quieres hablar con Dios pero las palabras no salen." value="$12.99" data-id="element-235" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/j3pqKXbBZq6wesZRk22rZt/Bono_2.png" title="BONO 2: Versículos para emergencias emocionales" description="La Biblia organizada por lo que sientes: miedo, tristeza, ansiedad, enojo y decisiones difíciles. Tu botiquín espiritual de emergencia." value="$9.99" data-id="element-236" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/9tPUezsQxzM6sv9RtC7BQg/Bono_3.png" title="BONO 3: Rutina espiritual de 5 minutos (sin culpa)" description="Para los días en los que no das más pero aun así necesitas conectar con Dios. Solo 5 minutos que pueden cambiar tu día entero." value="$7.99" data-id="element-237" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/sVbeCuRRXBRGHNV3smUteQ/Bono_4.png" title="BONO 4: 30 mensajes para cuando necesitas una señal" description="Mensajes bíblicos explicados en lenguaje simple y humano. Abre uno cada día o cuando sientas que necesitas escuchar algo de Dios." value="$14.99" data-id="element-238" />
          </div>

          {/* VALUE STACK - moved to PurchaseSection */}
        </div>
      </section>

      {/* ============ PURCHASE SECTION ============ */}
      <section className="py-20 bg-amber-50" data-id="element-239">
        <div className="max-w-6xl mx-auto px-4" data-id="element-240">
          <PurchaseSection data-id="element-241" />
        </div>
      </section>

      {/* ============ FINAL URGENCY CTA ============ */}
      <section className="py-20 bg-gradient-to-b from-amber-100 to-[#fffbf0]" data-id="element-242">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-243">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6" data-id="element-244">
            Cuando más lo necesitas,
            <br data-id="element-245" />
            <span className="text-amber-700" data-id="element-246">no deberías estar buscando…</span>
            <br data-id="element-247" />
            sino leyendo.
          </h2>
          <p className="text-lg text-gray-600 mb-4" data-id="element-248">
            No tienes que esperar. No tienes que saber más.
          </p>
          <p className="text-xl font-bold text-gray-800 mb-8" data-id="element-249">Solo empezar.</p>
          <button onClick={scrollToPurchase} className="inline-flex items-center justify-center bg-green-600 hover:bg-green-700 text-white text-xl font-bold py-5 px-12 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300" data-id="element-250">
            👉 Quiero acceso inmediato
          </button>
          <p className="text-sm text-gray-500 mt-4 flex items-center justify-center gap-2" data-id="element-251">
            <Shield className="w-4 h-4 text-green-600" data-id="element-252" />
            Compra segura · Garantía de 7 días · Acceso instantáneo
          </p>
        </div>
      </section>

      {/* ============ FAQ ============ */}
      <section className="py-20 bg-white" data-id="element-253">
        <div className="max-w-4xl mx-auto px-4" data-id="element-254">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gray-900 mb-12" data-id="element-255">
            ¿Tienes dudas? Aquí están las respuestas
          </h2>
          <FAQAccordion data-id="element-256" />
          <div className="text-center mt-10" data-id="element-257">
            <button onClick={scrollToPurchase} className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg inline-flex items-center justify-center" data-id="element-258">
              Ya no tengo dudas, ¡lo quiero! →
            </button>
          </div>
        </div>
      </section>

      {/* ============ FOOTER ============ */}
      <footer className="bg-gray-900 text-gray-400 py-12 text-center text-sm" data-id="element-259">
        <div className="max-w-4xl mx-auto px-4" data-id="element-260">
          <p className="mb-4" data-id="element-261">
            Este producto no garantiza la obtención de resultados. Cualquier
            referencia al desempeño de una estrategia no debe ser interpretada
            como una garantía de resultados.
          </p>
          <p className="mb-8" data-id="element-262">
            &copy; {new Date().getFullYear()} Qué leer en la Biblia. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-263">
            <span className="hover:text-white cursor-pointer" data-id="element-264">
              Términos y Condiciones
            </span>
            <span className="hover:text-white cursor-pointer" data-id="element-265">
              Política de Privacidad
            </span>
            <span className="hover:text-white cursor-pointer" data-id="element-266">Contacto</span>
          </div>
        </div>
      </footer>
    </div>;
}